export default theme => ({
  button: {
    borderRadius: 3,
  },
});
